import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import HeaderLogo from '../../components/HeaderLogo'

const GlobalErrorPage = () => {

  const handleReload = () => {
    window.location.href = window.location.origin
  };

  return (
    <Box className='px-6 pt-6 sm:px-10 sm:pt-6 relative flex flex-col h-full min-h-screen'>
    <HeaderLogo />
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        bgcolor: theme => theme.palette.background.default,
        padding: 3,
      }}
    >
      <ErrorOutlineIcon sx={{ fontSize: 60, color: theme => theme.palette.primary.main, mb: 2 }} />
      <Typography variant="h4" sx={{ fontWeight: 'bold', mb: 1 }}>
        Oops, something didn't go as planned.
      </Typography>
      <Typography variant="body1" sx={{ mb: 3, color: theme => theme.palette.text.secondary }}>
        We're having some trouble loading this page. Please try again.
      </Typography>
      <Button
        variant="contained"
        sx={{
          backgroundColor: theme => theme.palette.primary.dark,
          color: theme => theme.palette.common.white,
          padding: '10px 20px',
        }}
        onClick={handleReload}
      >
        Reload Page
      </Button>
    </Box>
    </Box>
  );
};

export default GlobalErrorPage;